import Vue from 'vue'
import Vuex from 'vuex'
import {productsCollection, db, customAuth} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js' 
import { async } from 'q';
Vue.use(Vuex)
export default {
    namespaced:true,
        state: {
            data:{
                productType:'',
                description:'',
                measureunit:'',
                existence: {},
            },
            record:[],
            typeProductRecord:{},
            productType:{},
            selectedKey:'',
            dialog: false,
        },
        mutations:{
            clean(state,key){
                Vue.delete(state.record,key)
            }
        },
    actions:{
        getAll: ( {state} )=>{
            state.record = []
            productsCollection.onSnapshot( data => {
                const record = []
                data.docs.map( item => {
                    record.push( { ...item.data(), key: item.id, existence: {...item.data().existence} } )
                })
                state.record = record
            })       
        },
        add:context=>{
            if(context.state.selectedKey==''){
                productsCollection.add( {...context.state.data,createdAt:new Date} ).then( () => {
                    context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo producto correctamente', { root: true })                  
                    cleanObject(context.state.data)
                    context.state.dialog = false
                })
            }else{  
                productsCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
                    context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })                                    
                    cleanObject(context.state.data)
                    context.state.dialog = false
                })
            }
        },
        massiveAdd: (context, data) =>{
            let batch = db.batch()
            let count = 0
            data.map(item => {
                batch.set(productsCollection.doc(), {...item, createdAt: new Date()})
                count++   
            })
            batch.commit().then( () =>  context.commit('Helpers/launchSnackbar', `Se han hecho ${count} registros`, { root: true }) )
        },
        clean:(context, key)=>{
            productsCollection.doc(key).delete().then(()=>{
                context.commit('Helpers/launchSnackbar', 'Se ha eliminado con éxito', { root: true })                
                context.commit('clean',key)})
        },

        getKeyByCode: ({state}, codigo) => {
            let inData = state.record.filter(item => String(item.codigo).trim() == String(codigo).trim())
            if( inData && inData[0] ) delete inData[0].existence 
            return inData[0]
        },
       
        get:(context,key)=>{
            productsCollection.doc(key).get().then(doc=>{
                context.state.data=doc.data()
                context.state.selectedKey=key
                context.state.dialog = true
            })
        },
   
        clearForm:(context)=>{
            context.state.dialog = false
            context.state.selectedKey = ''
            context.state.data = {
              name: '',
              createdAt: ''
            }
        },
        limpiar_inventarios: ({state, commit}) => {
            state.record.map(({key}) => productsCollection.doc(key).update( {existence: {TOTAL: 0} } ).then(()=>commit('Helpers/launchSnackbar', 'Se ha limpiezado las existencias', { root: true })) )
        }
    }, 
    getters:{
        record: state => state.record,  
        
        obtener_existencias: ({record} )=> (almacén, ocultar) => {
            let res = record.map(item => {
                let index = (item.existence) ? Object.keys(item.existence).filter(item => {
                    return item == almacén.trim()
                } )[0] : []
                return ({ ...item, existencia: item.existence && item.existence[index] ? item.existence[index] : 0  })
            } )

            return ocultar ? res : res.filter(item => item.existencia)
        },    
    }    
}